import FrameContainer from './FrameContainer';

export default FrameContainer;
